export default "__VITE_ASSET__DI64aDP5__"